<template>
  <div class="form-group row centix-vue-textinput" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
      <form-label :label="label" :info="info" labelCssClass="col-form-label col-md-4" :infoIconWrapper="infoIconWrapper"/>
      <div class="col-8" :class="{'disabled': this.isEnabled === false}">
        <div class="row">
          <div class="col">
            <input
              ref="input"
              type="text"
              autocomplete="off"
              class="form-control input-item"
              :class="{ filled_no_padding : hasValueWithoutPadding, filled : hasValueWithPadding, required : showRequiredClass }"
              v-model="innervalue"
              @input="onChange"
              @blur="onblur"
              @focus="onfocus"
              @keyup.esc="$event.target.blur()"
              @keyup.enter="onReturn"
              :placeholder="placeholder"
              :disabled="!isEnabled"
              maxlength="9">
          </div>
          <div class="col-auto">
            <verte
              :value="value"
              @input="chooseColor"
              model="hex"
              :enableAlpha="false"
              :draggable="true"
              picker="square"
              :showHistory="null">
              <a href="javascript:void(0)" class="btn btn-link">{{$t('product.stockindications.choose_color')}}</a>
              <div
                class="color-sample"
                :style="{ 'background-color': value }"
              ></div>
            </verte>
          </div>  
        </div>
      </div>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
  </div>
</template>

<script>
import FormMixin from '@/components/Form/formitem.js';
import Verte from 'verte';
import '@/styles/verte.css'; //originele import lijkt niet meer te werken. In de dev server (npm run serve), werkte de import wel, maar het werkte niet in de dist (npm run build)
                             // als oplossing is de css uit de node_packages gekopieerd naar de styles folder, en importen we die die nu vanuit de styles

export default {
mixins: [FormMixin],
components: { Verte },
props: {
  showPaddingWhenFilled: {
    type: Boolean,
    default: true
  }
},
data () {
  return {
    innervalue: '',
  };
},
mounted () {
  this.innervalue = this.value;
},
methods: {
  onChange: function (e) {
    this.$emit('change', this.innervalue);
    this.emitFormChange();
  },
  onblur: function () {
    this.$emit('blur', '');
  },
  onfocus: function () {
    this.$emit('focus');
  },
  chooseColor(value) {
    if (this.innervalue != value){
      this.innervalue = value;
      this.$emit('change', this.innervalue);
      this.emitFormChange();
    }
  }
},
watch: {
  value () {
    this.innervalue = this.value;
  }
},
computed: {
  hasValue: function () {
    return this.innervalue != null && this.innervalue.length > 0;
  },
  hasValueWithoutPadding: function () {
    return this.hasValue === true && this.showPaddingWhenFilled === false;
  },
  hasValueWithPadding: function () {
    return this.hasValue === true && this.showPaddingWhenFilled === true;
  },
  showRequiredClass: function () {
    if (this.required && !this.hasValue) {
      return true;
    } else {
      return false;
    }
  }
}
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';
.centix-vue-textinput {
  span.holder-span {
    position: relative;
    display: block;
    width: 100%;
  }
  &:hover {
    .clear-button {
      display: block;
    }
  }
  .clear-button {
    position: absolute;
    right: 15px;
    top: 0;
    background: url('/assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 50px;
    height: 100%;
    cursor: pointer;
    display: none;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid red;
      }
      &.filled {
        padding-right: 25px;
        border: 1px solid #80bdff;
      }
      &.filled_no_padding {
        border: 1px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
.color-sample {
  position: relative;
  display: inline-block;
  top: 6px;
  width: 20px;
  height: 20px;
}
</style>

<style lang="scss">
.verte__submit {
  display: none;
}
.verte__model {
  display: none;
}
.verte__guide {
  width: auto !important;
  white-space: nowrap;
}
.verte__guide:hover {
  background: transparent;
  padding: 0;
}
</style>